import { useEffect } from "react";
import { TokenKind } from "../../okta-auth";
import { removeOIDCCookie, removeRefreshTokenCookie } from "../../cookies";
import { getLogger } from "../../logger";
import { debugLog } from "@lululemon/auth-common";
export function useOktaErrorSubscription(_a) {
    var oktaAuth = _a.oktaAuth, onTokenError = _a.onTokenError;
    var logger = getLogger({ app: "login-app" });
    useEffect(function () {
        function onErrorHandler(error) {
            debugLog({ message: "TokenManager error: ".concat(error) });
            logger.error(new Error("Okta error: ".concat(error)), {
                tags: {
                    componentName: "useOktaErrorSubscription",
                    featureName: "useOktaErrorSubscription",
                    functionName: "onErrorHandler"
                }
            });
            if ((error === null || error === void 0 ? void 0 : error.tokenKey) === TokenKind.ACCESS) {
                removeOIDCCookie();
            }
            if ((error === null || error === void 0 ? void 0 : error.tokenKey) === TokenKind.REFRESH) {
                removeRefreshTokenCookie();
            }
            if (typeof onTokenError === "function") {
                onTokenError(error);
            }
        }
        oktaAuth.client.tokenManager.on("error", onErrorHandler);
        return function () {
            oktaAuth.client.tokenManager.off("error", onErrorHandler);
        };
    }, [oktaAuth, onTokenError]);
}
export default useOktaErrorSubscription;
